import { ManufacturingOrder } from './manufacturing-order';
import { ModelTimeline } from './summary/model-timeline';

export class Incidence {

  constructor(
    public hash?: string,
    public schedulerTaskHash?: string,
    public scrapped?: number,
    public recoverable?: number,
    public finished?: number,
    public cause?: number,
    public causeDescription?: string,
    public userErpCode?: number,
    public observation?: string,
    public type?: number,
    public isImputable?: boolean,
    public userHash?: string,
    public date?: number,
    public modelTimeLine?: ModelTimeline,
    public sentToErp?: boolean,
    public isFinished?: boolean,
    public isRecoverable?: boolean,
    public isScrapped?: boolean,
    public isPaused?: boolean,
    public manufacturingOrder?: ManufacturingOrder

  ) { }

  get putType() {
    if (this.isFinished) {
      return 'dashboard.autocontrol.finished';
    } else if (this.isRecoverable) {
      return 'dashboard.autocontrol.recoverable';
    } else if (this.isScrapped) {
      return 'dashboard.autocontrol.scrapped';
    } else if (this.isPaused) {
      return 'dashboard.autocontrol.paused';
    }
  }

  get putTypeQuantity() {
    if (this.scrapped > 0) {
      return this.scrapped;
    } else if (this.recoverable > 0) {
      return this.recoverable;
    } else if (this.finished > 0) {
      return this.finished;
    }
  }

  get propertyRemoveStatus() {
    if (this.modelTimeLine || this.sentToErp) {
      return 'icon-column hidden-icon';
    } else {
      return 'icon-column text-center';
    }
  }

  get propertyEditStatus() {
    if (this.sentToErp) {
      return 'icon-column hidden-icon';
    } else {
      return 'icon-column text-center';
    }
  }

  get pauseDuration() {
    const timeline = this.modelTimeLine;
    if (!timeline || !timeline.startTime || !timeline.endTime) {
      return '-';
    }
    const start = timeline.startTime;
    const end = timeline.endTime;
    if (typeof start !== 'number' || typeof end !== 'number' || isNaN(start) || isNaN(end) || end < start) {
      return '-';
    }
    let totalSeconds = Math.floor((end - start) / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    totalSeconds %= 3600;
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return `${hours}h ${minutes}m ${seconds}s`;
  }

  clone() {
    return new Incidence(
      this.hash,
      this.schedulerTaskHash,
      this.scrapped,
      this.recoverable,
      this.finished,
      this.cause,
      this.causeDescription,
      this.userErpCode,
      this.observation,
      this.type,
      this.isImputable,
      this.userHash,
      this.date,
      this.modelTimeLine,
      this.sentToErp,
      this.isFinished,
      this.isRecoverable,
      this.isScrapped,
      this.isPaused,
      this.manufacturingOrder
    );
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/incidence.ts